import { Auth0Client } from '@auth0/auth0-spa-js'

export default new Auth0Client({
  domain: AUTH0_DOMAIN,
  client_id: AUTH0_CLIENT_ID,
  redirect_uri: `${window.location.origin}/auth_callback`,
  audience: AUTH0_AUDIENCE,
  useRefreshTokens: true
})
